/**
 * Scoring (§1.9): per-player aggregates, area / pop shares, kill share and score, every tick.
 */
import { BALANCE } from '../balance.js';
import type { MatchState } from '../types.js';
import { sampleCurves } from './stats.js';

const KW = BALANCE.scoring.killWeight;

/** Refresh hexCount / cityCount / areaW / pop and shares + score for every player. */
export function refreshAggregates(state: MatchState): void {
  const w = state.world;
  const np = state.players.length;
  const hexes = new Int32Array(np + 1);
  const area = new Float64Array(np + 1);
  const pop = new Float64Array(np + 1);
  let totalArea = 0;
  for (let h = 0; h < w.landCount; h++) {
    const o = state.owner[h];
    const a = w.areaW[h];
    totalArea += a;
    hexes[o]++;
    area[o] += a;
    pop[o] += state.pop[h];
  }
  const cities = new Int32Array(np + 1);
  for (const e of state.entities.values()) if (e.kind === 'city') cities[e.owner]++;
  let totalPop = 0;
  for (let p = 1; p <= np; p++) totalPop += pop[p];
  let totalKilled = 0;
  for (const st of state.stats.players) totalKilled += st.popKilled;
  for (const p of state.players) {
    p.hexCount = hexes[p.id];
    p.cityCount = cities[p.id];
    p.areaW = area[p.id];
    p.pop = pop[p.id];
    p.areaShare = totalArea > 0 ? area[p.id] / totalArea : 0;
    p.popShare = totalPop > 0 ? pop[p.id] / totalPop : 0;
    p.killShare = totalKilled > 0 ? state.stats.players[p.id - 1].popKilled / totalKilled : 0;
    p.score = Math.round(1000 * ((1 - KW) * (0.5 * p.areaShare + 0.5 * p.popShare) + KW * p.killShare));
  }
  sampleCurves(state, totalArea > 0 ? area[0] / totalArea : 0);
}

/** Team score (teams mode) or the player's own score (FFA). */
export function teamScore(state: MatchState, team: number): number {
  let s = 0;
  for (const p of state.players) if (p.team === team) s += p.score;
  return s;
}
